/* eslint-disable import/no-unused-modules */
export const SET_IS_LOADING = 'SET_IS_LOADING';

export const ON_SELECT_PERIOD = 'ON_SELECT_PERIOD';
export const ON_INIT_FILTERS = 'ON_INIT_FILTERS';
export const ON_CHANGE_FILTERS = 'ON_CHANGE_FILTERS';
export const ON_CHANGE_LOCAL_FILTERS = 'ON_CHANGE_LOCAL_FILTERS';
export const ON_UPDATE_FILTERS_PAYLOAD = 'ON_UPDATE_FILTERS_PAYLOAD';
export const ON_CHANGE_FILTERS_BAR_HEIGHT = 'ON_CHANGE_BAR_HEIGHT';
export const RESET = 'RESET';

export const ON_SELECT_FILTER_SET = 'ON_SELECT_FILTER_SET';
export const ON_CLEAR_FILTER_SET = 'ON_CLEAR_FILTER_SET';
export const ON_UPDATE_FILTER_SET = 'ON_UPDATE_FILTER_SET';
export const ON_CREATE_FILTER_SET = 'ON_CREATE_FILTER_SET';
export const ON_DELETE_FILTER_SET = 'ON_DELETE_FILTER_SET';

export const SET_UI_REF = 'SET_UI_REF';
